export const mafia = {
    en: {
        night: {
            0: 'Night',
            1: 'First Night',
            2: 'Second Night',
            3: 'Third Night',
            4: 'Fourth Night',
            5: 'Fifth Night',
            6: 'Sixth Night',
            7: 'Seventh Night',
            8: 'Eighth Night',
            9: 'Ninth Night',
            10: 'Tenth Night',
        },
        day: {
            0: 'Day',
            1: 'First Day',
            2: 'Second Day',
            3: 'Third Day',
            4: 'Fourth Day',
            5: 'Fifth Day',
            6: 'Sixth Day',
            7: 'Seventh Day',
            8: 'Eighth Day',
            9: 'Ninth Day',
            10: 'Tenth Day',
        },
        button: {
            start_night: 'Go to Night',
            start_day: 'Go to Day',
            end_speech: 'End speech',
            i_am_done: "I'm Done",
            execute: 'Execute',
            pass: 'Pass',
            kill: 'Kill',
            save: 'Save',
            reveal: 'Reveal',
            start_new_game: 'Start new game',
        },
        announcements: {
            mafia_win: 'Banditos win!',
            citizens_win: 'Citizens win!',
        }
    },
    ru: {
        night: {
            0: 'Ночь',
            1: 'Первая Ночь',
            2: 'Вторая Ночь',
            3: 'Третья Ночь',
            4: 'Четвертая Ночь',
            5: 'Пятая Ночь',
            6: 'Шестая Ночь',
            7: 'Седьмая Ночь',
            8: 'Восьмая Ночь',
            9: 'Девятая Ночь',
            10: 'Десятая Ночь',
        },
        day: {
            0: 'День',
            1: 'Первый День',
            2: 'Второй День',
            3: 'Третий День',
            4: 'Четвертый День',
            5: 'Пятый День',
            6: 'Шестой День',
            7: 'Седьмой День',
            8: 'Восьмой День',
            9: 'Девятый День',
            10: 'Десятый День',
        },
        button: {
            start_night: 'Go to Night',
            start_day: 'Go to Day',
            end_speech: 'End speech',
            i_am_done: "I'm Done",
            execute: 'Execute',
            pass: 'Pass',
            kill: 'Kill',
            save: 'Save',
            reveal: 'Reveal',
            start_new_game: 'Start new game',
        },
        announcements: {
            mafia_win: 'Banditos win!',
            citizens_win: 'Citizens win!',
        }
    }
};
